import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ShopingBagView from '../../containers/MarketPlace/ShopingBag/ShopingBag';

const ShoppingBag = () => {
    const { bag } = useSelector(state => state.marketPlace)
    const dispatch = useDispatch()
    
    function isNumeric(value) {
        return /^\d+$/.test(value);
    }

    return <ShopingBagView bag={bag} />
}

export default ShoppingBag
